module.exports = __webpack_public_path__ + "img/img-78.b7373e1a.png";